import React, { useEffect, useState } from 'react';
import { Button, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketingForLocation } from '../../offices/offices-selectors';
import { capitalize } from 'lodash';
import { createLocation } from '../../offices/offices-actions';
import { marketingConfig as importedMarketingConfig } from '../configs/marketing-config';
import { getWriteTabsPermissions } from '../../../store/user/user-reducer';
import { formItemMap } from '@med-fe/ui';

function MarketingDetails({ locId }) {
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useDispatch();
  const data = useSelector((state) => getMarketingForLocation(state, locId));
  const isEditAllowed = useSelector(getWriteTabsPermissions).marketing;
  const [marketingFormConfig, setMarketingFormConfig] = useState(importedMarketingConfig);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ ...data });
      if (data.storefrontCategory === 'Other') {
        setMarketingFormConfig((prev) => ({
          ...prev,
          otherSfcComment: {
            ...prev.otherSfcComment,
            isVisible: true,
          },
        }));
      } else {
        setMarketingFormConfig((prev) => ({
          ...prev,
          otherSfcComment: {
            ...prev.otherSfcComment,
            isVisible: false,
          },
        }));
        form.setFieldValue('otherSfcComment', '');
      }
    }
  }, [locId]);

  const handleValuesChange = (changedValues: any) => {
    if ('storefrontCategory' in changedValues) {
      const selectedValue = changedValues.storefrontCategory;
      setMarketingFormConfig((prev) => ({
        ...prev,
        otherSfcComment: {
          ...prev.otherSfcComment,
          isVisible: selectedValue === 'Other',
        },
      }));

      if (selectedValue !== 'Other') {
        form.setFieldsValue({ otherSfcComment: '' });
      }
    }
    setIsDisabled(false);
  };

  const onSubmit = (formData: any) => {
    const payload = {
      ...formData,
      id: locId,
    };

    dispatch(createLocation(payload));
  };

  return (
    <Form
      form={form}
      className='marketing-details-form'
      layout='vertical'
      onFinish={(formData) => {
        onSubmit(formData);
        setIsDisabled(true);
      }}
      onValuesChange={handleValuesChange}
    >
      {Object.entries(marketingFormConfig).map(([key, value]: any) => {
        if (value.isVisible === false) return null;
        const params = { key, label: capitalize(value.label), name: key };
        return (
          <Form.Item
            {...params}
            key={key}
            /* rules={
                  key === 'otherSfcComment' && value.isVisible
                    ? [{ required: true, message: 'Please enter a comment for Storefront Category' }]
                    : []
                } */
          >
            {formItemMap(value, !isEditAllowed)}
          </Form.Item>
        );
      })}

      <Form.Item>
        <Button type='primary' htmlType='submit' className={'btn-form-action'} disabled={!isEditAllowed || isDisabled}>
          SAVE
        </Button>
      </Form.Item>
    </Form>
  );
}

export default MarketingDetails;
